var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAutoGenerated(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 73.5H100C101.105 73.5 102 72.6046 102 71.5V27.2778V11.5C102 10.3954 101.105 9.5 100 9.5H52C50.8954 9.5 50 10.3954 50 11.5V71.5C50 72.6046 50.8954 73.5 52 73.5Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 99.5H91C92.1046 99.5 93 98.6046 93 97.5V40.2778V19.5C93 18.3954 92.1046 17.5 91 17.5H32C30.8954 17.5 30 18.3954 30 19.5V97.5C30 98.6046 30.8954 99.5 32 99.5Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 109.5H81C82.1046 109.5 83 108.605 83 107.5V49.5556V28.5C83 27.3954 82.1046 26.5 81 26.5H19C17.8954 26.5 17 27.3954 17 28.5V107.5C17 108.605 17.8954 109.5 19 109.5Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67 83.5H33",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67 94.5H33",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5259 41.9847C59.3074 40.9632 58.5709 39.5 57.2719 39.5H47.1977C46.9249 39.498 46.6562 39.5685 46.4174 39.7047C46.1786 39.841 45.9778 40.0385 45.8342 40.2781L38.211 53.385C37.6095 54.4173 38.3655 55.7053 39.5731 55.7053H44.7167L39.8716 68.2061C39.1711 69.7871 41.0641 71.2332 42.3361 70.0893L62 50.8631H51.7263L58.5259 41.9847Z",
    fill: "#A3C5FF",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoGenerated);
export default __webpack_public_path__ + "static/media/auto-generated.c87648d9.svg";
export { ForwardRef as ReactComponent };